__turbopack_context__.v({
  "allJobTasksList": "_10--4G_allJobTasksList",
  "taskAssignees": "_10--4G_taskAssignees",
  "taskTextCell": "_10--4G_taskTextCell",
  "taskTitle": "_10--4G_taskTitle",
  "taskTitleCell": "_10--4G_taskTitleCell",
});
